module.exports = __webpack_public_path__ + "static/call-me-ted-028f608cc2f1ca495f956df96bde9325.jpg";